<template lang="pug">
  RegistrationForm(@submit="handleSubmit")
    template(#header)
      FormHeader(tag="h2") Зарегистрироваться на курс

    label(for="interest_id") Выберите поток:
    VueSelect(
      :options="interestOptions.trainingCoursesMap"
      v-model="trainingCourseId"
      :clearable="false"
      :searchable="false"
      :disabled="submitting || submitted"
      id="interest_id"
    )

    template(#checkboxes)
      CheckboxInput(
        v-model="company"
        name="company"
        :disabled="submitting || submitted"
      ) Нужен счет для юр. лица
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import CheckboxInput from './CheckboxInput';

  export default {
    components: {
      CheckboxInput,
    },

    computed: {
      ...mapState([
        'interestOptions',
        'interestType',
        'interestId',
        'submitting',
        'submitted',
      ]),

      customerType () {
        return this.company ? 'company' : 'private';
      },
    },

    data () {
      return {
        trainingCourseId: null,
        company: false,
      };
    },

    methods: {
      ...mapActions(['submit']),

      handleSubmit ({ email, name, phone, gdprConfirmed, newsletter, recaptchaResponse }) {
        const { interestId, interestType, customerType, trainingCourseId } = this;

        this.submit({
          email,
          name,
          phone,
          gdprConfirmed,
          newsletter,
          recaptchaResponse,
          interestType,
          interestId,
          interestOptions: {
            customerType,
            trainingCourseId: trainingCourseId.value,
          },
        });
      },
    },

    created () {
      this.trainingCourseId = this.interestOptions.trainingCoursesMap[0];
    },
  };
</script>
